import {createContext, useContext, useState} from 'react';

const defaultConfig = {
  heading: '',
  handleAddClick: null,
  isSearch: false,
  searchHandler: null,
  isAddingUser: false,
  isAddingGroup: false,
  isAddingDisciple: false,
  isAddingOrganisation: false,
  isAddingCampaign: false,
  isAddingDraftDay: false,
  hasUnsavedChanges: false,
  onSidebarNavAttempt: null
};

export const AdminLayoutContext = createContext(null);

export const useAdminLayoutContext = () => useContext(AdminLayoutContext);

export const AdminLayoutProvider = ({children}) => {
  const [config, setConfig] = useState(defaultConfig);

  return (
    <AdminLayoutContext.Provider value={{config, setConfig}}>
      {children}
    </AdminLayoutContext.Provider>
  );
};
